module.exports = __webpack_public_path__ + "img/index_fix_new.6e40faa7.png";